import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { api } from "../../sdk/utils";
import { IContentBlock } from "../../sdk/types/api";

export interface IUpdateBlockMutationParameters {
    productId: string;
    variantId: string;
    blockId: string;
    properties?: Record<string, unknown>;
    parentId?: string | null;
    afterId?: string | null;
}

export const useUpdateBlock = (
    invalidQueryKeys: string | string[],
): UseMutationResult<IContentBlock, unknown, IUpdateBlockMutationParameters> => {
    const auth = useAuth();
    const queryClient = useQueryClient();

    return useMutation<IContentBlock, unknown, IUpdateBlockMutationParameters>({
        mutationFn: async (parameters: IUpdateBlockMutationParameters) => {
            if (!auth.token) {
                throw new Error("Cannot update block without authorization token.");
            }

            const { productId, variantId, blockId, ...body } = parameters;

            return await api.Products.updateBlock(productId, variantId, blockId, body, auth.token);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(invalidQueryKeys);
        },
    });
};
